export default __webpack_public_path__ + "static/media/enviado.d0d98746.png";